export default "__VITE_ASSET__69bb0389__"